export default function Spinner ({coverEntirePage=false, message=""}) {
    let view;
    if(coverEntirePage){
       view = <div id={coverEntirePage ? 'spinner' : ''} className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
            <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}} >
                <span className="sr-only">Loading...</span>                
            </div>
        </div>
    }else{
        view = <div>
            <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}} >
                <span className="sr-only">Loading...</span>                
            </div>
            <div>{message}</div>
        </div>
    }

    return view;
} 